import React, { ChangeEvent } from "react";

export function isPostcodeValid(postcode: string) {
  const postcodeRegExp = /^\s*\d\d\d\d\s*$/;

  return postcodeRegExp.test(postcode);
}

const ValidationError: React.SFC = ({ children }) => <div className="gc-validation">{children}</div>;

function valueOrBlank(value: string | undefined) {
  return value ? value : "";
}

interface PostcodeState {
  isValid: boolean;
  value: string;
}

interface PostcodeProps {
  onChange: Function;
  className?: string;
  isRequiredField?: boolean;
  onBlur?: Function;
  onEnterKey?: Function;
  initialValue?: string;
}

export class Postcode extends React.Component<PostcodeProps, PostcodeState> {
  static defaultProps = {
    isRequiredField: false,
    onChange: () => {},
    value: ""
  };

  constructor(props: PostcodeProps) {
    super(props);
    this._onInputChangeHandler = this._onInputChangeHandler.bind(this);
    this._onInputBlurHandler = this._onInputBlurHandler.bind(this);
    this._onKeyDownHandler = this._onKeyDownHandler.bind(this);

    this.state = {
      isValid: true,
      value: valueOrBlank(props.initialValue)
    };
  }

  render() {
    let validationError;

    if (!this.state.isValid) {
      if (this.state.value.trim().length > 0) {
        validationError = <ValidationError>Invalid</ValidationError>;
      } else if (this.props.isRequiredField) {
        validationError = <ValidationError>Required</ValidationError>;
      }
    }

    return (
      <span style={{ position: "relative" }}>
        {validationError}

        <input
          className={`text-field text-field--new-style js-postcode-input t-postcode-input postcode-input ${this.props
            .className || ""}`}
          name="postcode"
          maxLength={4}
          onChange={this._onInputChangeHandler}
          onBlur={this._onInputBlurHandler}
          onFocus={event => event.target.setSelectionRange(0, event.target.value.length)}
          onKeyDown={this._onKeyDownHandler}
          data-error={!!validationError}
          type="tel"
          value={this.state.value}
        />
      </span>
    );
  }

  _onInputChangeHandler(event: ChangeEvent<HTMLInputElement>) {
    const newValue = event.target.value.trim();
    this.setState({
      isValid: true,
      value: newValue
    });

    if (newValue.length > 3) {
      const isValid = isPostcodeValid(newValue);
      this.setState({ isValid });

      if (isValid) {
        this.props.onChange(newValue);
      }
    }
  }

  _onInputBlurHandler() {
    const isValid = isPostcodeValid(this.state.value);
    this.setState({ isValid });

    if (this.props.onBlur && isValid) {
      this.props.onBlur(this.state.value.trim());
    }
  }

  _onKeyDownHandler(event: any) {
    if (event.key === "Enter") {
      const isValid = isPostcodeValid(this.state.value);
      this.setState({ isValid });

      if (isValid && this.props.onEnterKey) {
        this.props.onEnterKey(this.state.value.trim());
      }
    }
  }
}
